// THE PLAYER LOADS ON CLICK (D-21, O-4; plan 07A-17), shared by the storefront and student
// entrypoints (plan 11a-07). A page ships a sized poster and a play button marked
// `data-player-launch`, and nothing of the player: the first press imports `hls_player.js` —
// and hls.js only after the token arrives — so a visitor who never presses play downloads no
// player byte. The player is not React; `Gates::ReactBytes` walks the dynamic import to prove it.
//
// AN IMPORT THAT FAILS (deploy skew, a flaky network) shows the slot's error layer, set here
// because the player that sets it never arrived. Its retry reloads the page: the browser keeps a
// failed module failed for the document. Once the player has loaded, the retry is its own
// (07A-REVIEW C-WR-07).
const LAUNCHERS = "[data-player-launch], [data-player-layer~='error'] button"

export function listenForPlayerLaunch() {
  document.addEventListener("click", (event) => {
    const trigger = event.target instanceof Element ? event.target.closest(LAUNCHERS) : null
    const root = trigger?.closest("[data-video-player-state]")
    if (!root || root.hlsPlayer) return

    event.preventDefault()
    if (!trigger.hasAttribute("data-player-launch")) return window.location.reload()

    import("./hls_player.js").then(({ launch }) => launch(trigger)).catch(() => showError(root))
  })
}

// Focus on the play button just pressed moves to the retry that replaces it.
function showError(root) {
  const focused = root.contains(document.activeElement)
  root.dataset.videoPlayerState = "error"
  root.querySelectorAll("[data-player-layer]").forEach((layer) => {
    layer.hidden = !layer.dataset.playerLayer.split(" ").includes("error")
  })
  if (focused) root.querySelector("[data-player-layer~='error'] button")?.focus()
}
